<!-- src/components/dashboard/amocrm/AmoCrmLogs.vue -->
<template>
  <v-card flat class="pa-4 mt-6">
    <v-card-title class="headline d-flex justify-space-between">
      <span>Логи синхронизации с AmoCRM</span>
      <v-btn color="primary" small @click="loadLogs" :loading="loading">
        <v-icon left>mdi-refresh</v-icon>
        Обновить
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="logs"
        :items-per-page="15"
        :loading="loading"
        class="elevation-1"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100]
        }"
      >
        <template v-slot:item.created_at="{ item }">
          {{ new Date(item.created_at).toLocaleString() }}
        </template>

        <template v-slot:item.log_type="{ item }">
          <v-chip
            :color="getLogTypeColor(item.log_type)"
            small
            dark
          >
            {{ getLogTypeName(item.log_type) }}
          </v-chip>
        </template>

        <template v-slot:item.entity_type="{ item }">
          <v-chip
            color="secondary"
            small
            outlined
          >
            {{ getEntityName(item.entity_type) }}
          </v-chip>
        </template>

        <template v-slot:item.message="{ item }">
          <div class="log-message">{{ item.message }}</div>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn
            icon
            small
            @click="showDetails(item)"
          >
            <v-icon>mdi-information-outline</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
<!-- Продолжение AmoCrmLogs.vue -->

<v-dialog
      v-model="detailsDialog"
      max-width="800px"
    >
      <v-card>
        <v-card-title class="headline">
          Детали лога
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="detailsDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text v-if="selectedLog">
          <div class="mb-4">
            <strong>Время:</strong> {{ new Date(selectedLog.created_at).toLocaleString() }}
          </div>
          <div class="mb-4">
            <strong>Тип лога:</strong> {{ getLogTypeName(selectedLog.log_type) }}
          </div>
          <div class="mb-4">
            <strong>Тип сущности:</strong> {{ getEntityName(selectedLog.entity_type) }}
          </div>
          <div class="mb-4">
            <strong>ID сущности:</strong> {{ selectedLog.entity_id || 'Не указан' }}
          </div>
          <div class="mb-4">
            <strong>Сообщение:</strong> {{ selectedLog.message }}
          </div>

          <v-expansion-panels v-if="selectedLog.details">
            <v-expansion-panel>
              <v-expansion-panel-header>
                Детальная информация
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <pre class="log-details">{{ formatJson(selectedLog.details) }}</pre>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  name: 'AmoCrmLogs',

  data() {
    return {
      logs: [],
      loading: false,
      headers: [
        { text: 'Время', value: 'created_at', width: '20%' },
        { text: 'Тип', value: 'log_type', width: '10%' },
        { text: 'Сущность', value: 'entity_type', width: '10%' },
        { text: 'Сообщение', value: 'message' },
        { text: 'Действия', value: 'actions', align: 'center', sortable: false, width: '5%' }
      ],
      detailsDialog: false,
      selectedLog: null
    };
  },

  mounted() {
    this.loadLogs();
  },

  methods: {
    loadLogs() {
      this.loading = true;

      this.axios
        .get('/api/v1/integrations/amocrm/logs', {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then(response => {
          this.logs = response.data || [];
        })
        .catch(error => {
          console.error('Ошибка при загрузке логов', error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getLogTypeColor(type) {
      const colors = {
        'info': 'info',
        'error': 'error',
        'warning': 'warning',
        'success': 'success',
        'webhook': 'purple'
      };

      return colors[type] || 'grey';
    },

    getLogTypeName(type) {
      const names = {
        'info': 'Информация',
        'error': 'Ошибка',
        'warning': 'Предупреждение',
        'success': 'Успешно',
        'webhook': 'Вебхук'
      };

      return names[type] || type;
    },

    getEntityName(type) {
      const entities = {
        'lead': 'Сделка',
        'contact': 'Контакт',
        'company': 'Компания',
        'product': 'Товар',
        'client': 'Клиент',
        'booking': 'Бронирование',
        'car': 'Автомобиль',
        'webhook': 'Вебхук'
      };

      return entities[type] || type;
    },

    showDetails(log) {
      this.selectedLog = log;
      this.detailsDialog = true;
    },

    formatJson(data) {
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (e) {
          return data;
        }
      }

      return JSON.stringify(data, null, 2);
    }
  }
}
</script>

<style scoped>
.log-message {
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.log-details {
  white-space: pre-wrap;
  overflow-x: auto;
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 4px;
  font-family: monospace;
}
</style>
